module.exports = __webpack_public_path__ + "static/media/(V)_MG_5770_-_Cia_Termal_Beachewear_-_Moda_Feminina_-_Acessorios.64b0b46d.jpg";